import useSelector from 'components/Booking-new/hooks';
import isArrayNotEmpty from 'utils/isArrayNotEmpty';
import stepTypes from 'components/Booking-new/modules/Steps/types';

export default function (code) {
  const { results } = useSelector(state => ({
    locationsData: state?.allSteps?.find(step => step.type === stepTypes.location)?.data?.locations,
  }));

  const allLocations = results?.locationsData;

  return isArrayNotEmpty(allLocations) && allLocations.find(location => location.code === code);
}
